import React, {useEffect, useRef, useState} from 'react';
import classNames from 'classnames';
import {useDisclosure} from 'hooks/useDisclosure';
import {OptionType} from 'interfaces';

import {DropdownContainer} from '../Form/Select/DetachedSearchSelect/DropdownContainer';

import {ButtonDropdown} from './ButtonDropdown';
import {dropdownStyle} from './dropdown-style';

interface ComboBoxProps {
  label: string;
  options: OptionType[];
  onChange: (option: OptionType | null) => void;
  placeholder?: string;
  className?: string;
  value?: OptionType | null;
}

export default function SingleComboBox({
  options,
  label,
  onChange,
  placeholder = 'Select an option',
  className,
  value,
}: ComboBoxProps) {
  const {isOpen, close, toggle} = useDisclosure();
  const outerRef = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLButtonElement>(null);
  const [selectedOption, setSelectedOption] = useState<OptionType | null>(null);

  const currentValue = value ? value : selectedOption;

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [value]);

  const onSelectHandler = (option: OptionType) => {
    onChange(option);
    close();
    if (!value) {
      setSelectedOption(option);
    }
  };

  return (
    <div
      className={classNames('relative h-auto isolate w-full', className)}
      ref={outerRef}
    >
      <DropdownContainer
        isOpen={isOpen}
        onClose={close}
        target={
          <ButtonDropdown
            ref={ref}
            onClick={toggle}
            label={label}
            selectedOutput={currentValue?.label ?? placeholder}
            isOpen={isOpen}
          />
        }
        styles={{
          dropdownMenu: () => ({...dropdownStyle, position: 'fixed'}),
        }}
      >
        <div
          style={{width: ref.current?.clientWidth}}
          className={classNames(
            `z-10 bg-white rounded-2xl shadow-md flex flex-col cursor-pointer`,
          )}
        >
          {options.map(option => (
            <button
              key={option.label}
              className="px-4 py-3 hover:bg-gray-100"
              onClick={() => onSelectHandler(option)}
            >
              <p className="text-left font-light text-gray-900">
                {option.label}
              </p>
            </button>
          ))}
        </div>
      </DropdownContainer>
    </div>
  );
}
